export enum DataExport {
    profile = 'profile',
    quarterResponses = 'quarterResponses',
    userBehavior = 'userBehavior',
}
